











 













const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveTeamMemberIntegrationAuthMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GitLabProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JiraServerProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AzureDevOpsProviderRowTeamMember"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GcalProviderRowTeamMember"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MattermostProviderRowTeamMemberIntegrations"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MSTeamsProviderRowTeamMemberIntegrations"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveTeamMemberIntegrationAuthSuccess",
  "abstractKey": null
};

(node ).hash = "f81a309fef6fa1bf1720756b643c0885";

export default node;
